export default __webpack_public_path__ + "static/media/bottyAi-2.e5e4e4c5.png";